import type { Component } from 'vue';
import TitleBlock from './TitleBlock.vue';
import JJ from './JJ.vue';

export default new Map<string, Component>([
  ['TitleBlock', TitleBlock],
  ['JJ', JJ],
]);



